"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f108 = void 0;
exports.f108 = {
    "laramanik": [
        24
    ],
    "lampung nyo": [
        42
    ],
    "lampung": [
        42,
        4353,
        4354
    ],
    "lampong": [
        42,
        4353,
        4354
    ],
    "lesser antillean french creole": [
        65
    ],
    "lesser": [
        65
    ],
    "lucian": [
        65
    ],
    "lc": [
        65,
        2173
    ],
    "lucia": [
        65,
        2173
    ],
    "log acoli": [
        66
    ],
    "log": [
        66
    ],
    "lwo": [
        66,
        4202,
        719,
        1956,
        4554
    ],
    "lwoo": [
        66,
        4202
    ],
    "lëbacoli": [
        66
    ],
    "lawng": [
        71,
        4787
    ],
    "longchuan achang": [
        71
    ],
    "longchuan": [
        71
    ],
    "lidzonka": [
        89
    ],
    "ludama": [
        93
    ],
    "luoba": [
        95,
        1521,
        1520,
        94
    ],
    "lho-pa": [
        94,
        95,
        1520,
        1521
    ],
    "lhoba": [
        94,
        95,
        1520,
        1521
    ],
    "luoba, boga’er": [
        95,
        94
    ],
    "language": [
        102,
        103,
        119,
        124,
        139,
        463,
        464,
        474,
        475,
        481,
        750,
        751,
        753,
        1006,
        1063,
        1207,
        1315,
        1402,
        1513,
        1631,
        1632,
        1633,
        1634,
        1635,
        1641,
        1643,
        1647,
        1648,
        1653,
        1944,
        1969,
        1972,
        2058,
        2071,
        2292,
        2294,
        2295,
        2306,
        2350,
        2476,
        2477,
        2478,
        2593,
        2787,
        2788,
        2790,
        2794,
        2820,
        2883,
        2887,
        2918,
        2963,
        3034,
        3041,
        3059,
        3060,
        3096,
        3109,
        3110,
        3129,
        3185,
        3219,
        3224,
        3249,
        3250,
        3257,
        3361,
        3385,
        3388,
        3414,
        3425,
        3439,
        3626,
        3724,
        4055,
        4234,
        4390,
        4490,
        4493,
        4496,
        4498,
        4499,
        4500,
        4503,
        4504,
        4505,
        4556,
        4663,
        4728,
        5043,
        5076,
        5090,
        5259,
        5262,
        5280,
        5326,
        5352,
        5689,
        5692,
        5697,
        5699,
        5818,
        5881,
        6120,
        6177,
        6292,
        6305,
        6309,
        6310,
        6312,
        6315,
        6318,
        6319,
        6321,
        6387,
        6559,
        6602,
        6603,
        6604,
        6756,
        6799,
        6802,
        6811,
        6826,
        6944,
        6955,
        7077,
        7083,
        7087,
        7144,
        7146,
        7219,
        7239,
        7281,
        7291,
        7292,
        7733,
        7741,
        7743,
        7745,
        7751,
        7879,
        7923,
        7925,
        7937,
        7940,
        8077,
        8139,
        8140,
        8141,
        8190,
        8488,
        8499,
        8541,
        8548,
        8787,
        8793,
        8906,
        8907,
        9052,
        9157,
        457,
        458,
        465,
        1074,
        2664,
        3202,
        3336,
        3688,
        3832,
        3833,
        3957,
        4405,
        5432,
        5714,
        5893,
        6685,
        7234,
        7235,
        9077,
        9078,
        9108,
        9109,
        9184
    ],
    "lower circassian": [
        108,
        109,
        110
    ],
    "lower": [
        5682,
        8412,
        569,
        1408,
        1918,
        1968,
        6947,
        7301,
        7769,
        108,
        109,
        110,
        457,
        458,
        1443,
        1581,
        3601,
        3602,
        3712,
        3804,
        6102,
        6142,
        6168,
        6257,
        6882,
        7177,
        7799,
        8268,
        8459,
        8555,
        9051
    ],
    "lowland adyghe": [
        108,
        109,
        110
    ],
    "lowland": [
        1524,
        6412,
        108,
        109,
        110,
        1447,
        1448,
        1656,
        3218,
        4581,
        4807,
        4824,
        6424,
        6822,
        7303,
        7650,
        8923,
        8924,
        8925,
        8926
    ],
    "lsa": [
        119,
        474
    ],
    "lengua de señas argentina": [
        119
    ],
    "lengua": [
        5130,
        119,
        1631,
        1634,
        1635,
        1643,
        1648,
        2058,
        2233,
        2242,
        2294,
        2918,
        4500,
        4504,
        4728,
        5076,
        5352,
        6192,
        6292,
        6387,
        7144,
        7925,
        8140,
        8141
    ],
    "lembala": [
        122
    ],
    "lezow": [
        124
    ],
    "legbo": [
        151
    ],
    "leggbo": [
        151
    ],
    "leangba": [
        157
    ],
    "langimar": [
        163
    ],
    "labin agta": [
        169
    ],
    "labin": [
        169
    ],
    "lake buhi west": [
        175
    ],
    "lake": [
        4415,
        175,
        495,
        677,
        553,
        6090,
        6257,
        7752
    ],
    "lélémrin": [
        180
    ],
    "louma": [
        182
    ],
    "la": [
        5467,
        4235,
        4313,
        4326,
        4495,
        5620,
        5621,
        6373,
        7262,
        8186,
        568,
        608,
        1440,
        1524,
        1528,
        1669,
        2466,
        2968,
        4058,
        4208,
        4461,
        4594,
        4812,
        4819,
        5341,
        5449,
        5464,
        5556,
        5704,
        5987,
        6124,
        6255,
        6354,
        6364,
        6399,
        6401,
        6404,
        6419,
        6444,
        6447,
        7303,
        7318,
        7392,
        7653,
        7752,
        8141,
        8646,
        182,
        266,
        788,
        789,
        934,
        1079,
        1101,
        1102,
        1103,
        1549,
        3005,
        3006,
        3007,
        3014,
        3240,
        3285,
        3347,
        3552,
        3650,
        3702,
        3703,
        4019,
        4147,
        4224,
        4229,
        4230,
        4231,
        4439,
        4499,
        4545,
        4879,
        4880,
        5199,
        5349,
        5350,
        5408,
        5438,
        5938,
        6007,
        6018,
        6129,
        6130,
        6134,
        6178,
        6247,
        6363,
        6736,
        6956,
        7065,
        7081,
        7147,
        7389,
        7459,
        7474,
        7632,
        7672,
        7762,
        7769,
        7894,
        8504,
        8763
    ],
    "lao people's democratic republic": [
        182,
        266,
        788,
        789,
        934,
        1079,
        1101,
        1102,
        1103,
        1549,
        3005,
        3006,
        3007,
        3014,
        3240,
        3285,
        3347,
        3552,
        3650,
        3702,
        3703,
        4019,
        4147,
        4224,
        4229,
        4230,
        4231,
        4439,
        4499,
        4545,
        4879,
        4880,
        5199,
        5349,
        5350,
        5408,
        5438,
        5938,
        6007,
        6018,
        6129,
        6130,
        6134,
        6178,
        6247,
        6363,
        6736,
        6956,
        7065,
        7081,
        7147,
        7389,
        7459,
        7474,
        7632,
        7672,
        7762,
        7769,
        7894,
        8504,
        8763
    ],
    "lao": [
        4439,
        5554,
        7867,
        3702,
        3703,
        3704,
        4203,
        6133,
        6134,
        6135,
        6247,
        6300,
        6365,
        7023,
        7024,
        7577,
        7740,
        8753,
        8882,
        7878,
        9044,
        9045,
        182,
        266,
        788,
        789,
        934,
        1079,
        1101,
        1102,
        1103,
        1549,
        3005,
        3006,
        3007,
        3014,
        3240,
        3285,
        3347,
        3552,
        3650,
        4019,
        4147,
        4224,
        4229,
        4230,
        4231,
        4499,
        4545,
        4879,
        4880,
        5199,
        5349,
        5350,
        5408,
        5438,
        5938,
        6007,
        6018,
        6129,
        6130,
        6178,
        6363,
        6736,
        6956,
        7065,
        7081,
        7147,
        7389,
        7459,
        7474,
        7632,
        7672,
        7762,
        7769,
        7894,
        8504,
        8763
    ],
    "longa": [
        198,
        8314
    ],
    "leeward caribbean english creole": [
        200
    ],
    "leeward": [
        200
    ],
    "lishana aturaya": [
        203
    ],
    "lishana": [
        4491,
        203,
        204,
        3094,
        7268,
        7277
    ],
    "lishana didán": [
        204
    ],
    "lishanid noshan": [
        204
    ],
    "lishanid": [
        204,
        7706
    ],
    "levantine": [
        224,
        368,
        537
    ],
    "levantine arabic": [
        224,
        368
    ],
    "lolobi-akpafu": [
        246
    ],
    "leealowa": [
        263
    ],
    "larike-wakasihu": [
        271
    ],
    "lur": [
        281,
        4541
    ],
    "luri": [
        4254,
        4475,
        4541,
        4476,
        281,
        1058
    ],
    "lorenzo": [
        288,
        9145
    ],
    "lam-si-hoan": [
        292
    ],
    "loghtha siryanooytha": [
        307,
        308,
        309,
        310
    ],
    "loghtha": [
        307,
        308,
        309,
        310
    ],
    "lebanese": [
        368
    ],
    "lebanese-syrian arabic": [
        368
    ],
    "lebanese-syrian": [
        368
    ],
    "libano-mexicano": [
        368
    ],
    "lipan": [
        380
    ],
    "lipan apache": [
        380
    ],
    "lukep": [
        386
    ],
    "literary arabic": [
        409,
        426
    ],
    "literary": [
        4564,
        4565,
        3724,
        409,
        426,
        997,
        999,
        1000,
        1001
    ],
    "lb": [
        419,
        4013,
        6128
    ],
    "lebanon": [
        419,
        4013,
        6128
    ],
    "ly": [
        3645,
        3646,
        420,
        517,
        582,
        2627,
        3330,
        4234,
        7241
    ],
    "libya": [
        420,
        517,
        582,
        2627,
        3330,
        4234,
        7241
    ],
    "lokono": [
        454
    ],
    "lokono dian": [
        454
    ],
    "luccumi": [
        454
    ],
    "lower egypt arabic": [
        457,
        458
    ],
    "lsaf": [
        463,
        464
    ],
    "lsaf ivoirienne": [
        463,
        464
    ],
    "lsci": [
        463,
        464
    ],
    "lsfa": [
        463,
        464
    ],
    "lsh": [
        463,
        464
    ],
    "langue des signes américaine": [
        463,
        464
    ],
    "langue": [
        463,
        464,
        474,
        1006,
        2350,
        2477,
        4490,
        6799,
        7146,
        8548
    ],
    "langue des signes congolaise": [
        463,
        464
    ],
    "langue des signes de côte d’ivoire": [
        463,
        464
    ],
    "langue des signes de l’afrique francophone": [
        463,
        464
    ],
    "l’afrique": [
        463,
        464
    ],
    "langue des signes du congo": [
        463,
        464
    ],
    "langue des signes d’afrique francophone": [
        463,
        464
    ],
    "langue des signes franco-africaine": [
        463,
        464
    ],
    "langue des signes haïtienne": [
        463,
        464
    ],
    "langue des signes algérienne": [
        474
    ],
    "lghh alesharh aljza’er": [
        474
    ],
    "lghh": [
        474
    ],
    "leonese": [
        478
    ],
    "langilan": [
        489
    ],
    "lake buhi": [
        495
    ],
    "lolopani": [
        518
    ],
    "lahu": [
        4315,
        4322,
        535
    ],
    "levantine bedawi arabic": [
        537
    ],
    "levantine bedawi spoken arabic": [
        537
    ],
    "lobaye": [
        568
    ],
    "lower aranda": [
        569
    ],
    "lower southern aranda": [
        569
    ],
    "leyigha": [
        580
    ],
    "libyan": [
        4234,
        582
    ],
    "libyan arabic": [
        582
    ],
    "libyan spoken arabic": [
        582
    ],
    "libyan vernacular arabic": [
        582
    ],
    "leh": [
        637
    ],
    "lambi": [
        642
    ],
    "lombe": [
        642
    ],
    "lombi": [
        4401,
        642
    ],
    "lipkawa": [
        653,
        3681
    ],
    "labbu": [
        660,
        661
    ],
    "libaali": [
        674
    ],
    "lake babine": [
        677
    ],
    "lange": [
        693
    ],
    "laut": [
        5735,
        696,
        1958,
        2009,
        2609,
        4244,
        5193,
        5194,
        5958,
        6972
    ],
    "land bajaw": [
        702
    ],
    "land": [
        702
    ],
    "lo": [
        2723,
        4263,
        4465,
        4466,
        719,
        818,
        1397,
        2977,
        7208,
        7392
    ],
    "lemeting": [
        721
    ],
    "lobat": [
        724,
        725
    ],
    "lan-bi bai": [
        744,
        4215
    ],
    "lan-bi": [
        744,
        4215
    ],
    "leme": [
        744
    ],
    "lemei": [
        744
    ],
    "lemo": [
        744
    ],
    "lushui": [
        744
    ],
    "lahuli": [
        769,
        770,
        4222,
        4223,
        4192,
        4193
    ],
    "lahuli of bunan": [
        769,
        770
    ],
    "lyase": [
        779
    ],
    "lyase-ne": [
        779
    ],
    "laos": [
        4499,
        789
    ],
    "laisaw": [
        795
    ],
    "laizo": [
        795
    ],
    "langkay": [
        795
    ],
    "lengotia": [
        806,
        807
    ],
    "lobi": [
        4441,
        854
    ],
    "loi": [
        7577,
        858,
        4326,
        5028
    ],
    "loi-likila": [
        858
    ],
    "limbudza": [
        859
    ],
    "lishan didan": [
        863
    ],
    "lishan": [
        863,
        4491
    ],
    "lishan dideni": [
        863
    ],
    "labuhan": [
        872,
        873
    ],
    "l’est": [
        887
    ],
    "laes baikeno": [
        908
    ],
    "laes": [
        908
    ],
    "lais meto": [
        908
    ],
    "lais": [
        908
    ],
    "lavella": [
        913
    ],
    "lr": [
        918,
        1132,
        1133,
        1296,
        1795,
        1920,
        2174,
        2359,
        2372,
        2599,
        2618,
        2684,
        2735,
        2763,
        2771,
        2782,
        2785,
        3785,
        3877,
        3878,
        3912,
        3939,
        3946,
        3972,
        4340,
        4451,
        4452,
        4702,
        5265,
        5999,
        7520,
        8050,
        8051
    ],
    "liberia": [
        3878,
        3877,
        4451,
        4452,
        918,
        1132,
        1133,
        1296,
        1795,
        1920,
        2174,
        2359,
        2372,
        2599,
        2618,
        2684,
        2735,
        2763,
        2771,
        2782,
        2785,
        3785,
        3912,
        3939,
        3946,
        3972,
        4340,
        4702,
        5265,
        5999,
        7520,
        8050,
        8051
    ],
    "lame": [
        944
    ],
    "limassa": [
        948
    ],
    "leone": [
        6826,
        3834,
        4692,
        4693,
        949,
        1184,
        1194,
        2206,
        2363,
        2376,
        3828,
        3829,
        3934,
        4324,
        4449,
        7419
    ],
    "lis": [
        952,
        3249,
        6944
    ],
    "lisi": [
        952
    ],
    "lino": [
        966
    ],
    "lobobangi": [
        980
    ],
    "lhasa tibetan": [
        997,
        999,
        1000,
        1001
    ],
    "lhasa": [
        997,
        999,
        1000,
        1001
    ],
    "literary tibetan": [
        997,
        999,
        1000,
        1001
    ],
    "lsm": [
        1006,
        4663,
        4728,
        8548
    ],
    "lasima": [
        1006
    ],
    "langue des signes bambara": [
        1006
    ],
    "langue des signes malienne": [
        1006
    ],
    "lalok": [
        1009
    ],
    "lêm berom": [
        1012
    ],
    "lêm": [
        1012
    ],
    "luwuli": [
        1020
    ],
    "lugger": [
        1035
    ],
    "lori": [
        1058,
        4475,
        4541,
        6706
    ],
    "lori-bakhtiāri": [
        1058
    ],
    "lori-ye khaveri": [
        1058
    ],
    "lori-ye": [
        1058,
        4541
    ],
    "lave": [
        1079,
        1078,
        1080
    ],
    "laveh": [
        1078,
        1079,
        1080
    ],
    "love": [
        1078,
        1079,
        1080
    ],
    "luang": [
        4289,
        5039,
        1104,
        6845,
        6846,
        6847,
        6848,
        7477
    ],
    "lorang bukit": [
        1117
    ],
    "lorang": [
        4483,
        1117
    ],
    "landu": [
        1151
    ],
    "lundu": [
        1151
    ],
    "lactan": [
        1155
    ],
    "latagnun": [
        1155
    ],
    "latan": [
        1155
    ],
    "leyte": [
        1219
    ],
    "lagota": [
        1227
    ],
    "láá": [
        1231
    ],
    "laa": [
        1231
    ],
    "láá láá bwamu": [
        1231
    ],
    "lingi": [
        1233
    ],
    "libenge": [
        1244
    ],
    "libua": [
        1244
    ],
    "libwali": [
        1244
    ],
    "lawa": [
        4249,
        4552,
        1305,
        1361,
        4553,
        7924
    ],
    "lua": [
        1305,
        4553,
        4879,
        4880,
        5471,
        6300
    ],
    "libras": [
        1315
    ],
    "lsb": [
        1315,
        4490
    ],
    "língua brasileira de sinais": [
        1315
    ],
    "língua": [
        1315,
        6321,
        7940,
        8896
    ],
    "língua de sinais brasileira": [
        1315
    ],
    "língua de sinais dos centros urbanos brasileiros": [
        1315
    ],
    "laalaa": [
        1332
    ],
    "lala": [
        5680,
        1332,
        8890
    ],
    "lehar": [
        1332
    ],
    "linguará": [
        1349
    ],
    "lower chehalis": [
        1408
    ],
    "lemi": [
        1412,
        1418
    ],
    "likhy": [
        1419
    ],
    "lawktu": [
        1424
    ],
    "lente": [
        1431
    ],
    "lower chinook": [
        1443
    ],
    "lagoon chuukese": [
        1445
    ],
    "lagoon": [
        1445
    ],
    "low mari": [
        1447,
        1448
    ],
    "low": [
        5376,
        2474,
        2693,
        5375,
        1447,
        1448,
        4519,
        4605,
        6086
    ],
    "lowland mari": [
        1447,
        1448
    ],
    "lugovo mari": [
        1447,
        1448
    ],
    "lugovo": [
        1447,
        1448
    ],
    "larga": [
        1472
    ],
    "loang": [
        1481
    ],
    "lygoravetlen": [
        1508
    ],
    "lealao": [
        1516
    ],
    "latani": [
        1516
    ],
    "lealao chinantec": [
        1516
    ],
    "laitu": [
        1519,
        4383
    ],
    "laikhy": [
        1519
    ],
    "laitu chin": [
        1519
    ],
    "laitu kheu": [
        1519
    ],
    "ledu": [
        1519
    ],
    "leitu": [
        1519
    ],
    "luoba, yidu": [
        1521,
        1520
    ],
    "lajltyaygi": [
        1524
    ],
    "lowland oaxaca chontal": [
        1524
    ],
    "lautu": [
        1525
    ],
    "lautu chin": [
        1525
    ],
    "lawhtu": [
        1525
    ],
    "lachao-yolotepec chatino": [
        1528
    ],
    "lachao-yolotepec": [
        1528
    ],
    "ladakhi": [
        4226,
        1541
    ],
    "lai": [
        8804,
        4050,
        4326,
        6201,
        1545,
        3008,
        6121,
        7524,
        7825,
        7826
    ],
    "lai chin": [
        1545
    ],
    "lai hawlh": [
        1545
    ],
    "lai pawi": [
        1545
    ],
    "lalana": [
        1548
    ],
    "lalana chinantec": [
        1548
    ],
    "laimon": [
        1568
    ],
    "laymon-cochimi": [
        1568
    ],
    "laymonem": [
        1568
    ],
    "lower cowlitz": [
        1581
    ],
    "lonwolwol": [
        1600
    ],
    "lungwa santome": [
        1607
    ],
    "lungwa": [
        1607,
        6574
    ],
    "lsc": [
        1631,
        1634,
        1643
    ],
    "lengua de señas catalana": [
        1631
    ],
    "lengua de signos catalana": [
        1631
    ],
    "llengua de signes catalana": [
        1631
    ],
    "llengua": [
        1631,
        8141
    ],
    "llenguatge de signes": [
        1631
    ],
    "llenguatge": [
        1631
    ],
    "lscu": [
        1634
    ],
    "lengua de señas cubana": [
        1634
    ],
    "lengua de señas cubanas": [
        1634
    ],
    "lense": [
        1635
    ],
    "lsch": [
        1635
    ],
    "lengua de señas chilena": [
        1635
    ],
    "lenguaje chileno de signos": [
        1635
    ],
    "lenguaje": [
        1635,
        1648,
        4728,
        5076,
        5352,
        6292
    ],
    "lenguaje de señas": [
        1635
    ],
    "lengua de señas colombiana": [
        1643
    ],
    "lengua manual colombiana": [
        1643
    ],
    "lesco": [
        1648
    ],
    "lengua de señas costaricenses": [
        1648
    ],
    "lengua de señas costarricense": [
        1648
    ],
    "lenguaje de señas costarricense": [
        1648
    ],
    "lowland chatino": [
        1656
    ],
    "lakty’añ": [
        1672,
        1673,
        1674
    ],
    "licang": [
        1736
    ],
    "loodiya": [
        1749
    ],
    "li": [
        4247,
        4326,
        4341,
        4342,
        4776,
        5468,
        2089,
        4152,
        4153,
        4154,
        7236,
        1789,
        2797
    ],
    "liechtenstein": [
        1789,
        2797
    ],
    "lu": [
        3005,
        3006,
        3007,
        3008,
        3009,
        3645,
        3646,
        5737,
        8748,
        8749,
        1790,
        2442,
        4217,
        6335
    ],
    "luxembourg": [
        1790,
        2442,
        4217,
        6335
    ],
    "lunaapeew": [
        1802
    ],
    "lem": [
        1803
    ],
    "lengese": [
        1812
    ],
    "luzimba": [
        1836
    ],
    "lifou": [
        1842
    ],
    "lifouan": [
        1842
    ],
    "lifu": [
        1842
    ],
    "lakota": [
        4371,
        1847
    ],
    "lakota dida": [
        1847
    ],
    "lango": [
        4202,
        4434,
        1848,
        6076
    ],
    "lakaalong": [
        1852
    ],
    "lambong": [
        1852
    ],
    "le wurrung": [
        1868
    ],
    "le": [
        1868,
        4326,
        4533,
        4534,
        4535,
        3645,
        3646,
        7386,
        7387
    ],
    "lewurru": [
        1868
    ],
    "lewurrung": [
        1868
    ],
    "liduma": [
        1896
    ],
    "lower grand valley dani": [
        1918
    ],
    "lendu": [
        4269,
        1923
    ],
    "laany": [
        1928
    ],
    "lani": [
        1928
    ],
    "lukpa": [
        1943
    ],
    "legba": [
        1943
    ],
    "logba": [
        4308,
        1943
    ],
    "lokpa": [
        1943
    ],
    "lugba": [
        1943
    ],
    "lalawa": [
        1959,
        7134
    ],
    "lela": [
        1959,
        4270
    ],
    "lluzykie": [
        1968
    ],
    "lower lusatian": [
        1968
    ],
    "lusatian": [
        1968,
        3058
    ],
    "lower sorbian": [
        1968
    ],
    "luzycki": [
        1968
    ],
    "labuk-kinabatangan": [
        1981
    ],
    "labuk kadazan": [
        1981
    ],
    "labuk": [
        1981
    ],
    "labuk-kinabatangan kadazan": [
        1981
    ],
    "lotud": [
        1990
    ],
    "lsi rai": [
        2012
    ],
    "lsi": [
        2012
    ],
    "lhoskad": [
        2044
    ],
    "lsec": [
        2058
    ],
    "lengua de señas de ecuador": [
        2058
    ],
    "lik": [
        2073
    ],
    "libie": [
        2084
    ],
    "ldes": [
        2099
    ],
    "ls": [
        2175,
        7157
    ],
    "lesotho": [
        2175,
        7157
    ],
    "lengua norte": [
        2233
    ],
    "lengua sur": [
        2242
    ],
    "lingvo internacia": [
        2243
    ],
    "lingvo": [
        2243
    ],
    "lizu": [
        2253
    ],
    "lusu": [
        2253,
        4341,
        4342
    ],
    "latinoamericano": [
        2257
    ],
    "latin america and the caribbean": [
        2257
    ],
    "latin": [
        4185,
        7164,
        2257
    ],
    "lim": [
        2292
    ],
    "lughat al-ishaara al-masriya": [
        2292
    ],
    "lughat": [
        2292,
        3414
    ],
    "lughat al-‘ishāra al-maṣriyya": [
        2292
    ],
    "lesa": [
        2294,
        4284,
        6932
    ],
    "lessa": [
        2294
    ],
    "lengua de señas salvadoreñas": [
        2294
    ],
    "lawrence": [
        2297,
        2298
    ],
    "lamut": [
        2317,
        2318
    ],
    "ligaoeño": [
        2349
    ],
    "lsq": [
        2350
    ],
    "langue signe quebecars": [
        2350
    ],
    "langue des signes": [
        2350
    ],
    "langue des signes canadiens français": [
        2350
    ],
    "langue des signes du québec": [
        2350
    ],
    "langue des signes québécoise": [
        2350
    ],
    "lingam": [
        2402
    ],
    "lingo": [
        2402
    ],
    "lololo": [
        2406
    ],
    "lifoma": [
        2412
    ],
    "louisiana french": [
        2466
    ],
    "louisiana": [
        4461,
        2466
    ],
    "louisiane": [
        2466
    ],
    "louisianais": [
        2466,
        4461
    ],
    "lwizyàn": [
        2466,
        4461
    ],
    "larat": [
        2467
    ],
    "lsf": [
        2477,
        7146
    ],
    "langue des signes française": [
        2477,
        7146
    ],
    "lali": [
        2500,
        4257
    ],
    "lir talo": [
        2521
    ],
    "lir": [
        2521,
        4332,
        4512
    ],
    "lohar, gade": [
        2574
    ],
    "lohar": [
        2574,
        4316
    ],
    "lohari": [
        2574
    ],
    "lohpitta": [
        2574
    ],
    "laal": [
        2588
    ],
    "lila": [
        2629,
        2630,
        8858
    ],
    "lila ke": [
        2629
    ],
    "labogai": [
        2647
    ],
    "loko": [
        4449,
        2649,
        8745
    ],
    "longli": [
        2654
    ],
    "longli mulao": [
        2654
    ],
    "lee mághdì": [
        2690
    ],
    "lee": [
        2690,
        3367
    ],
    "laame": [
        2695
    ],
    "lere": [
        2710
    ],
    "lensegua": [
        2790
    ],
    "lhaíca": [
        2821
    ],
    "loucheux": [
        2848
    ],
    "lugwere": [
        2852
    ],
    "likoya": [
        2863
    ],
    "luhaya": [
        2909
    ],
    "lesho": [
        2918
    ],
    "lengua de señas hondureñas": [
        2918
    ],
    "luba": [
        3911,
        4517,
        2927,
        4518,
        4524,
        6995,
        6996,
        7039
    ],
    "luba-hemba": [
        2927
    ],
    "lamang": [
        2937
    ],
    "laamang": [
        2937
    ],
    "lesu": [
        2967
    ],
    "luwian": [
        2969,
        8528
    ],
    "large": [
        2973,
        2974,
        2975
    ],
    "lul": [
        2973,
        2974,
        2975
    ],
    "large flowery miao": [
        2973,
        2974,
        2975
    ],
    "luopohe": [
        2983
    ],
    "lobohe miao": [
        2983
    ],
    "lobohe": [
        2983
    ],
    "luobo river miao": [
        2983
    ],
    "luobo": [
        2983
    ],
    "luobohe hmong": [
        2983
    ],
    "luobohe": [
        2983
    ],
    "luopohe hmong": [
        2983
    ],
    "luopohe miao": [
        2983
    ],
    "lug": [
        2986
    ],
    "long comb miao": [
        2997,
        2998
    ],
    "long": [
        7778,
        4470,
        7474,
        2997,
        2998,
        4058,
        6979,
        8997,
        8998,
        9002,
        9184,
        6845,
        6846,
        6847,
        6848
    ],
    "lopsided comb miao": [
        2997,
        2998
    ],
    "lopsided": [
        2997,
        2998
    ],
    "laria": [
        3001
    ],
    "leng": [
        3005,
        3006,
        3007,
        3008,
        3009
    ],
    "leeg": [
        3005,
        3006,
        3007,
        3008,
        3009
    ],
    "lu man zi": [
        3005,
        3006,
        3007,
        3008,
        3009
    ],
    "lu miao": [
        3005,
        3006,
        3007,
        3008,
        3009
    ],
    "lanka kol": [
        3019,
        3020,
        3021,
        3022,
        3023
    ],
    "lanka": [
        3019,
        3020,
        3021,
        3022,
        3023,
        6725,
        6864,
        6865,
        7083,
        7298,
        8070
    ],
    "luy": [
        3047,
        3048
    ],
    "longhorn miao": [
        3050
    ],
    "longhorn": [
        3050
    ],
    "lama": [
        4210,
        4215,
        6426,
        7599,
        3089
    ],
    "lishana akhni": [
        3094
    ],
    "lishana noshan": [
        3094
    ],
    "langaj": [
        3096
    ],
    "langay": [
        3096
    ],
    "lii hawu": [
        3099
    ],
    "lii": [
        5415,
        3099
    ],
    "limba": [
        4324,
        4393,
        3117,
        4217,
        5260,
        6559,
        6575,
        6576,
        6578,
        6579,
        5320
    ],
    "luidakho-luisukha-lutirichi": [
        3134
    ],
    "liangshan yi": [
        3169,
        3170
    ],
    "liangshan": [
        3169,
        3170
    ],
    "liangshan yi-nuosu": [
        3169,
        3170
    ],
    "lolo": [
        4375,
        3169,
        3170,
        8909,
        4208,
        5723,
        8913
    ],
    "lulumo": [
        3182
    ],
    "lingotes": [
        3196
    ],
    "lanoon": [
        3197
    ],
    "lanun": [
        3197,
        4318
    ],
    "limera": [
        3203
    ],
    "lowland inga": [
        3218
    ],
    "lingua italiana dei segni": [
        3249
    ],
    "lingua": [
        4294,
        4295,
        6212,
        3249,
        6944
    ],
    "lingua dei segni italiana": [
        3249,
        6944
    ],
    "la‘az": [
        3269
    ],
    "laro": [
        4484,
        3273,
        4206
    ],
    "luba-tiempo itneg": [
        3275
    ],
    "luba-tiempo": [
        3275
    ],
    "laulabu": [
        3309
    ],
    "langwij": [
        3315
    ],
    "languij": [
        3315
    ],
    "langui jumieka": [
        3315
    ],
    "langui": [
        3315
    ],
    "limonese creole": [
        3315
    ],
    "limonese": [
        3315
    ],
    "limón creole english": [
        3315
    ],
    "limón": [
        3315
    ],
    "leeanuwa": [
        3317
    ],
    "lojban": [
        3331
    ],
    "lahji": [
        3341,
        3342,
        3343
    ],
    "la’la’": [
        3344
    ],
    "lingbe": [
        3355
    ],
    "lingbee": [
        3355
    ],
    "li-ngbee": [
        3355
    ],
    "lasjar": [
        3358
    ],
    "lavrung": [
        3373
    ],
    "labir": [
        3386
    ],
    "labur": [
        3386
    ],
    "liriny": [
        3392
    ],
    "lirin": [
        3392
    ],
    "loba": [
        3410,
        4465,
        4466
    ],
    "liu": [
        3414,
        8898
    ],
    "lughat al-ishāra al-urdunia": [
        3414
    ],
    "lughat il-ishaarah il-urduniyyah": [
        3414
    ],
    "li-kari-li": [
        3486
    ],
    "labi-kare": [
        3490
    ],
    "lubila": [
        3508
    ],
    "lubilo": [
        3508
    ],
    "laukanu": [
        3517
    ],
    "lukete": [
        3527
    ],
    "lbəlbaliyya": [
        3530
    ],
    "luritja": [
        6160,
        3534
    ],
    "l’extreme": [
        3542
    ],
    "lashon kedar": [
        3548,
        3549
    ],
    "lashon": [
        3548,
        3549
    ],
    "lt": [
        3548,
        4390,
        4506,
        4507,
        5898,
        6822
    ],
    "lithuania": [
        3548,
        4390,
        4506,
        4507,
        5898,
        6822
    ],
    "lemba": [
        3569,
        5260
    ],
    "lower kinnauri": [
        3601,
        3602,
        3712
    ],
    "lumpur": [
        3626
    ],
    "lakahia": [
        3634
    ],
    "lü": [
        3645,
        3646
    ],
    "lue": [
        3645,
        3646,
        4111,
        4112
    ],
    "lusi": [
        3654
    ],
    "likanu": [
        3667
    ],
    "likelo": [
        3668
    ],
    "lokele": [
        3668
    ],
    "lgalige": [
        3672
    ],
    "lao kang": [
        3702,
        3703,
        3704
    ],
    "lao terng": [
        3702,
        3703,
        3704
    ],
    "luu": [
        3702,
        3703,
        3704
    ],
    "lam": [
        3710,
        4824
    ],
    "lindoe": [
        3787
    ],
    "lindu": [
        3787
    ],
    "linduan": [
        3787
    ],
    "lambego": [
        3789
    ],
    "loanda mbundu": [
        3793
    ],
    "loanda": [
        3793
    ],
    "loande": [
        3793
    ],
    "luanda": [
        3793
    ],
    "lunda": [
        4528,
        3793,
        6568
    ],
    "limos": [
        3803
    ],
    "linimos": [
        3803
    ],
    "limos kalinga": [
        3803
    ],
    "limos-liwan kalinga": [
        3803
    ],
    "limos-liwan": [
        3803
    ],
    "lower tanudan": [
        3804
    ],
    "lower tanudan kalinga": [
        3804
    ],
    "lubuagan": [
        3822
    ],
    "lubuagan kalinga": [
        3822
    ],
    "liar": [
        3838,
        3839
    ],
    "lhukonzo": [
        3863
    ],
    "lagwan": [
        3867
    ],
    "lagouane": [
        3867
    ],
    "lagwane": [
        3867
    ],
    "logone": [
        3867
    ],
    "likɔɔnl": [
        3879
    ],
    "luba kaonde": [
        3911
    ],
    "lokutsu": [
        3975
    ],
    "larkye": [
        3986
    ],
    "leta": [
        4001
    ],
    "likango": [
        4005,
        4183
    ],
    "likan antai": [
        4040
    ],
    "likan": [
        4040
    ],
    "likanantaí": [
        4040
    ],
    "lipe": [
        4040
    ],
    "lerabain": [
        4048
    ],
    "lay": [
        4050,
        4313
    ],
    "laku": [
        4056,
        4322
    ],
    "long hair cuna": [
        4058
    ],
    "lahta": [
        4065
    ],
    "lahta karen": [
        4065
    ],
    "likwala": [
        4075
    ],
    "likouala": [
        4075
    ],
    "likuba": [
        4126
    ],
    "luckiamute": [
        4143
    ],
    "lukamiute": [
        4143
    ],
    "lekaningi": [
        4174
    ],
    "likaningi": [
        4174
    ],
    "laka": [
        4203,
        4207,
        4177,
        4220,
        8858
    ],
    "lakka": [
        4177,
        4203
    ],
    "lakka mbum": [
        4177
    ],
    "latina": [
        4185
    ],
    "lapuyan subanun": [
        4186
    ],
    "lapuyan": [
        4186
    ],
    "lapuyen": [
        4186
    ],
    "linear a": [
        4187
    ],
    "linear": [
        4187
    ],
    "lacandon": [
        4188
    ],
    "lacandón": [
        4188
    ],
    "lakantún": [
        4188
    ],
    "ladino": [
        4189,
        4190,
        4191
    ],
    "lešon sepharadim": [
        4189,
        4190,
        4191
    ],
    "lešon": [
        4189,
        4190,
        4191
    ],
    "lafofa": [
        4194
    ],
    "langi": [
        4195,
        4202
    ],
    "lahnda": [
        4196,
        4197,
        4198,
        4199,
        4200
    ],
    "lahanda": [
        4196,
        4197,
        4198,
        4199,
        4200
    ],
    "lahndi": [
        4196,
        4197,
        4198,
        4199,
        4200
    ],
    "lambya": [
        4201
    ],
    "lambia": [
        4201
    ],
    "lambwa": [
        4201
    ],
    "lango (uganda)": [
        4202
    ],
    "leb lango": [
        4202
    ],
    "leb": [
        4202
    ],
    "leb laŋo": [
        4202
    ],
    "laŋo": [
        4202
    ],
    "leb-lango": [
        4202
    ],
    "lëblango": [
        4202
    ],
    "lëblaŋo": [
        4202
    ],
    "leb lano": [
        4202
    ],
    "lano": [
        4202
    ],
    "laka (nigeria)": [
        4203
    ],
    "lao habe": [
        4203
    ],
    "lau": [
        4391,
        4203,
        4392
    ],
    "lalia": [
        4204
    ],
    "lamba": [
        4205,
        4210
    ],
    "laru": [
        4206,
        4484
    ],
    "laranchi": [
        4206
    ],
    "larawa": [
        4206
    ],
    "laga": [
        4207
    ],
    "laka (chad)": [
        4207
    ],
    "làgà": [
        4207
    ],
    "laqua": [
        4208
    ],
    "larteh": [
        4209
    ],
    "late": [
        4508,
        4509,
        4209
    ],
    "lete": [
        4209
    ],
    "lama (togo)": [
        4210
    ],
    "losso": [
        4210,
        5589
    ],
    "laba": [
        4211
    ],
    "loloda": [
        4440,
        4211
    ],
    "lauje": [
        4212
    ],
    "laudje": [
        4212
    ],
    "lalung": [
        4213,
        4214
    ],
    "lama bai": [
        4215
    ],
    "lanping": [
        4215
    ],
    "lae": [
        4216
    ],
    "lahe": [
        4216
    ],
    "luxembourgish": [
        4217
    ],
    "lëtzebuergesch": [
        4217
    ],
    "letzburgisch": [
        4217
    ],
    "letzeburgesch": [
        4217
    ],
    "letzeburgisch": [
        4217
    ],
    "limba săsească": [
        4217
    ],
    "luxembourgeois": [
        4217
    ],
    "luxemburgian": [
        4217
    ],
    "luxemburgish": [
        4217
    ],
    "lui": [
        4218,
        4563
    ],
    "label": [
        4219
    ],
    "lakkia": [
        4220
    ],
    "lajia": [
        4220
    ],
    "lakia": [
        4220
    ],
    "lakja": [
        4220
    ],
    "lakkja": [
        4220
    ],
    "lak": [
        4221,
        6905
    ],
    "lakh": [
        4221
    ],
    "laki": [
        4363,
        4221,
        4238
    ],
    "lahul": [
        4316,
        6711,
        6712,
        4222,
        4223
    ],
    "lahauli": [
        4222,
        4223
    ],
    "lahouli": [
        4222,
        4223
    ],
    "lahuli tinan": [
        4222,
        4223
    ],
    "laopang": [
        4224
    ],
    "laopa": [
        4224,
        4302
    ],
    "laopan": [
        4224
    ],
    "la’bi": [
        4225
    ],
    "la'bi": [
        4225
    ],
    "ladak": [
        4226
    ],
    "ladakh": [
        4226
    ],
    "ladakh skat": [
        4226
    ],
    "ladaphi": [
        4226
    ],
    "ladhakhi": [
        4226
    ],
    "ladwags": [
        4226
    ],
    "libon": [
        4227
    ],
    "libon bikol": [
        4227
    ],
    "libongeño": [
        4227
    ],
    "lodhi": [
        4228
    ],
    "lodha": [
        4228
    ],
    "lodi": [
        4228
    ],
    "lohi": [
        4228
    ],
    "lozi": [
        4467,
        4228
    ],
    "lamet": [
        4229,
        4230
    ],
    "lamed": [
        4229,
        4230
    ],
    "lemet": [
        4229,
        4230
    ],
    "laven": [
        4231
    ],
    "laweenjru": [
        4231
    ],
    "loven": [
        4231
    ],
    "laewamba": [
        4232
    ],
    "laewomba": [
        4232
    ],
    "laiwomba": [
        4232
    ],
    "lohorung": [
        4233,
        4485
    ],
    "loarung·khanawa": [
        4233
    ],
    "loharung khanawa": [
        4233
    ],
    "loharung": [
        4233
    ],
    "lohorong": [
        4233
    ],
    "lohorong kha": [
        4233
    ],
    "lohorong khap": [
        4233
    ],
    "lohorung kha": [
        4233
    ],
    "lohorung khap": [
        4233
    ],
    "lohrung": [
        4233
    ],
    "lohrung khap": [
        4233
    ],
    "lohrung-khanawa": [
        4233
    ],
    "lorung": [
        4233,
        4485
    ],
    "lorung kha": [
        4233
    ],
    "lorung khap": [
        4233
    ],
    "libyan sign language": [
        4234
    ],
    "lachi": [
        4235,
        4551,
        4495
    ],
    "la chi": [
        4235
    ],
    "lachí": [
        4235
    ],
    "laji": [
        4235,
        4495
    ],
    "lati": [
        4235
    ],
    "lipulio": [
        4235
    ],
    "lipuljo": [
        4235
    ],
    "labu": [
        4236,
        4522
    ],
    "labo": [
        8884,
        4236,
        5182,
        7010
    ],
    "labu’": [
        4236
    ],
    "lavatbura-lamusong": [
        4237
    ],
    "lamasong": [
        4237
    ],
    "lolaki": [
        4238
    ],
    "lawangan": [
        4239
    ],
    "luwangan": [
        4239
    ],
    "lamalama": [
        4240
    ],
    "lama-lama": [
        4240
    ],
    "lamu-lamu": [
        4240
    ],
    "lamulamul": [
        4240
    ],
    "lardil": [
        4241
    ],
    "ladil": [
        4241
    ],
    "laierdila": [
        4241
    ],
    "lardill": [
        4241
    ],
    "legenyem": [
        4242
    ],
    "laganyan": [
        4242
    ],
    "lola": [
        4243
    ],
    "lonchong": [
        4244
    ],
    "loncong": [
        4244
    ],
    "lontjong": [
        4244
    ],
    "lubu": [
        4245
    ],
    "luchazi": [
        4246
    ],
    "lucazi": [
        4246
    ],
    "lujash": [
        4246
    ],
    "lujasi": [
        4246
    ],
    "lujazi": [
        4246
    ],
    "lutchaz": [
        4246
    ],
    "lutshase": [
        4246
    ],
    "luxage": [
        4246
    ],
    "lisela": [
        4247
    ],
    "li enyorot": [
        4247
    ],
    "liet enjorot": [
        4247
    ],
    "liet": [
        4247
    ],
    "lavangai": [
        4248
    ],
    "lavongai": [
        4248
    ],
    "lawa, western": [
        4249
    ],
    "lava": [
        4249
    ],
    "lavua": [
        4249,
        4552
    ],
    "lavüa": [
        4249
    ],
    "l’wa": [
        4249
    ],
    "luhu": [
        4250
    ],
    "lisabata-nuniali": [
        4251
    ],
    "lisabata": [
        4251
    ],
    "lunga": [
        4253
    ],
    "lungu": [
        4253,
        7315
    ],
    "lúr": [
        4254
    ],
    "lenyima": [
        4255
    ],
    "lamja-dengsa-tola": [
        4256
    ],
    "laari": [
        4257
    ],
    "laadi": [
        4257
    ],
    "ladi": [
        4257
    ],
    "lari": [
        4481,
        4257
    ],
    "lemoro": [
        4258
    ],
    "limorro": [
        4258
    ],
    "leelau": [
        4259
    ],
    "lelau": [
        4259
    ],
    "lelo": [
        4259
    ],
    "libbo": [
        4260
    ],
    "libo": [
        4260
    ],
    "landoma": [
        4261
    ],
    "landouman": [
        4261
    ],
    "landuma": [
        4261
    ],
    "láadan": [
        4262
    ],
    "loo": [
        4263,
        5639
    ],
    "loh": [
        4263,
        5554
    ],
    "lotsu-piri": [
        4264
    ],
    "lufu": [
        4265
    ],
    "lega-shabunda": [
        4266
    ],
    "lega": [
        4266
    ],
    "lega-malinga": [
        4266
    ],
    "leka-igonzabale": [
        4266
    ],
    "lala-bisa": [
        4267
    ],
    "leco": [
        4268
    ],
    "leko": [
        5366,
        4268
    ],
    "lyélé": [
        4270
    ],
    "lele": [
        4276,
        4376,
        4378,
        4387,
        4270
    ],
    "lyela": [
        4270
    ],
    "lyele": [
        4270
    ],
    "lyæ̀læ": [
        4270
    ],
    "lelemi": [
        4271
    ],
    "lɛlɛmi": [
        4271
    ],
    "lafana": [
        4271
    ],
    "lefana": [
        4271
    ],
    "lɛfana": [
        4271
    ],
    "lenje": [
        4272
    ],
    "lengi": [
        4272
    ],
    "lenji": [
        4272
    ],
    "lemio": [
        4273
    ],
    "lengola": [
        4274
    ],
    "lengora": [
        4274
    ],
    "leipon": [
        4275
    ],
    "lele (democratic republic of congo)": [
        4276
    ],
    "lemande": [
        4277
    ],
    "lenca": [
        4278
    ],
    "leti": [
        4279,
        4512,
        4289
    ],
    "leti (cameroon)": [
        4279
    ],
    "lepcha": [
        4280,
        4281
    ],
    "lapcha": [
        4280,
        4281
    ],
    "lapche": [
        4280,
        4281
    ],
    "lembena": [
        4282
    ],
    "lembena pii": [
        4282
    ],
    "lenkau": [
        4283
    ],
    "lese": [
        4284
    ],
    "lesse": [
        4284
    ],
    "lissi": [
        4284
    ],
    "lesing-atui": [
        4285
    ],
    "lesing-gelimi": [
        4285
    ],
    "lemakot": [
        4286
    ],
    "lemusmus": [
        4286
    ],
    "lamma": [
        4287
    ],
    "lamma’": [
        4287
    ],
    "lemma": [
        4287
    ],
    "ledo": [
        4288
    ],
    "ledo kaili": [
        4288
    ],
    "lteri lgona": [
        4289
    ],
    "lteri": [
        4289
    ],
    "lgona": [
        4289
    ],
    "letri lgona": [
        4289
    ],
    "letri": [
        4289
    ],
    "literi lagona": [
        4289
    ],
    "literi": [
        4289
    ],
    "lagona": [
        4289
    ],
    "limola": [
        4290
    ],
    "lemolang": [
        4290
    ],
    "limolang": [
        4290
    ],
    "lezgi": [
        4291,
        4292
    ],
    "lezghi": [
        4291,
        4292
    ],
    "lezghian": [
        4291,
        4292
    ],
    "lezgian": [
        4291,
        4292
    ],
    "lezgin": [
        4291,
        4292
    ],
    "lefa": [
        4293
    ],
    "lefa’": [
        4293
    ],
    "lɨfa’": [
        4293
    ],
    "lingua franca nova": [
        4294,
        4295
    ],
    "luganda": [
        4296,
        4297
    ],
    "lùgáànda": [
        4296,
        4297
    ],
    "lungga": [
        4298
    ],
    "luga": [
        4298
    ],
    "lunqa": [
        4298
    ],
    "luqa": [
        4298
    ],
    "laghu": [
        4299
    ],
    "lagu": [
        4299
    ],
    "lugbara": [
        4300,
        4301,
        4519
    ],
    "lʉgbara tɨ": [
        4300,
        4301
    ],
    "lʉgbara": [
        4300,
        4301
    ],
    "logbara": [
        4300,
        4301
    ],
    "lubarati": [
        4300,
        4301
    ],
    "lugbarati": [
        4300,
        4301
    ],
    "laghuu": [
        4302
    ],
    "lengilu": [
        4303
    ],
    "lingarak": [
        4304
    ],
    "langalanga": [
        4305
    ],
    "lega-mwenga": [
        4306
    ],
    "lega-ntara": [
        4306
    ],
    "leka-shile": [
        4306
    ],
    "leka-sile": [
        4306
    ],
    "lengo": [
        4309
    ],
    "lugitama": [
        4310
    ],
    "longgu": [
        4311
    ],
    "logu": [
        4311
    ],
    "ligenza": [
        4312
    ],
    "ligendza": [
        4312
    ],
    "laha": [
        4313,
        4314
    ],
    "la ha": [
        4313
    ],
    "la ha ung": [
        4313
    ],
    "laha (viet nam)": [
        4313
    ],
    "laxa": [
        4313
    ],
    "liik": [
        4313
    ],
    "laha (indonesia)": [
        4314
    ],
    "lahu shi": [
        4315
    ],
    "lad hur si": [
        4315
    ],
    "lad": [
        4315
    ],
    "lung": [
        7954,
        4315
    ],
    "lahu si": [
        4315
    ],
    "lahu xi": [
        4315
    ],
    "lahu-xi": [
        4315
    ],
    "lahu-shi": [
        4315
    ],
    "lahusi": [
        4315
    ],
    "lohar, lahul": [
        4316
    ],
    "lahul lohar": [
        4316
    ],
    "lhomi": [
        4317
    ],
    "lhoket": [
        4317
    ],
    "lhomi dzyükki keccyok": [
        4317
    ],
    "lhomiki keccyok": [
        4317
    ],
    "lhomiki": [
        4317
    ],
    "lahanan": [
        4318
    ],
    "lanan": [
        4318
    ],
    "lhokpu": [
        4319
    ],
    "lhobikha": [
        4319
    ],
    "lo-toga": [
        4321
    ],
    "loh-toga": [
        4321
    ],
    "ladhof": [
        4322
    ],
    "lahu na": [
        4322
    ],
    "lahuna": [
        4322
    ],
    "launa": [
        4322
    ],
    "limburgish": [
        4323
    ],
    "limberger": [
        4323
    ],
    "limbourgeois": [
        4323
    ],
    "limburgan": [
        4323
    ],
    "limburger": [
        4323
    ],
    "limburgian": [
        4323
    ],
    "limburgic": [
        4323
    ],
    "limburgisch": [
        4323
    ],
    "limburgs": [
        4323
    ],
    "limburgs plat": [
        4323
    ],
    "lèmburgs": [
        4323
    ],
    "limba, west-central": [
        4324
    ],
    "likum": [
        4325
    ],
    "lindau": [
        4327
    ],
    "lindrou": [
        4327
    ],
    "likila": [
        4328
    ],
    "limbu": [
        4329,
        4330
    ],
    "limbo": [
        4329,
        4330
    ],
    "limboo": [
        4329,
        4330
    ],
    "lumbu": [
        4530,
        4329,
        4330
    ],
    "ligbi": [
        4331
    ],
    "ligwi": [
        4331
    ],
    "lihir": [
        4332
    ],
    "ligurian": [
        4333,
        8522
    ],
    "ligure": [
        4333
    ],
    "lika": [
        4334
    ],
    "liliko": [
        4334
    ],
    "liko": [
        4334
    ],
    "lillooet": [
        4335,
        4336
    ],
    "liki": [
        4337,
        7025
    ],
    "likpe": [
        4338
    ],
    "libido": [
        4339
    ],
    "liberian english": [
        4340
    ],
    "liberian": [
        4340
    ],
    "liberian pidgin english": [
        4340
    ],
    "lisu": [
        4341,
        4342,
        4471,
        4472
    ],
    "leisu": [
        4341,
        4342
    ],
    "leshuoopa": [
        4341,
        4342
    ],
    "lesuo": [
        4341,
        4342
    ],
    "li-hsaw": [
        4341,
        4342
    ],
    "li-shaw": [
        4341,
        4342
    ],
    "lip’a": [
        4341,
        4342
    ],
    "lisaw": [
        4341,
        4342
    ],
    "lishu": [
        4341,
        4342
    ],
    "liso": [
        4341,
        4342
    ],
    "lissu": [
        4341,
        4342
    ],
    "loisu": [
        4341,
        4342
    ],
    "lu-tzu": [
        4341,
        4342
    ],
    "logorik": [
        4343
    ],
    "liguri": [
        4343
    ],
    "liv": [
        4344
    ],
    "livonian": [
        4344
    ],
    "livõ kel": [
        4344
    ],
    "livõ": [
        4344
    ],
    "lv": [
        4344,
        4496,
        4510,
        4542,
        4543,
        9072
    ],
    "latvia": [
        4344,
        4496,
        4510,
        4542,
        4543,
        9072
    ],
    "liabuku": [
        4346
    ],
    "linda": [
        4347
    ],
    "libinza": [
        4348
    ],
    "libindja": [
        4348
    ],
    "libinja": [
        4348
    ],
    "leboni": [
        4350
    ],
    "laiyolo": [
        4351
    ],
    "li’o": [
        4352
    ],
    "li'o": [
        4352
    ],
    "lio": [
        4352
    ],
    "lionese": [
        4352
    ],
    "lampung api": [
        4353,
        4354
    ],
    "lampung pesisir": [
        4353,
        4354
    ],
    "lakalei": [
        4357
    ],
    "lukabaras": [
        4358
    ],
    "lahlu": [
        4359
    ],
    "lakondê": [
        4360
    ],
    "lukenhe": [
        4361
    ],
    "lukenye": [
        4361
    ],
    "lukenyi": [
        4361
    ],
    "lakha": [
        4362
    ],
    "leki": [
        4363
    ],
    "laeko-libuat": [
        4365
    ],
    "laeko": [
        4365
    ],
    "laeko-limbuat": [
        4365
    ],
    "lakon": [
        4367
    ],
    "lakona": [
        4367
    ],
    "lakona bay": [
        4367
    ],
    "lakȟólʼiyapi": [
        4371
    ],
    "lakhota": [
        4371
    ],
    "lakhótiya": [
        4371
    ],
    "lakotiyapi": [
        4371
    ],
    "lakȟótiyapi": [
        4371
    ],
    "lokoya": [
        4373
    ],
    "loirya": [
        4373
    ],
    "lokoiya": [
        4373
    ],
    "lokoja": [
        4373
    ],
    "loquia": [
        4373
    ],
    "lowoi": [
        4373
    ],
    "lala-roba": [
        4374
    ],
    "lele (guinea)": [
        4376
    ],
    "ladin": [
        4377
    ],
    "lele (papua new guinea)": [
        4378
    ],
    "lele hai": [
        4378
    ],
    "luf": [
        4379
    ],
    "lole": [
        4380,
        6092
    ],
    "loleh": [
        4380
    ],
    "lamu": [
        4381,
        8890
    ],
    "laali": [
        4382
    ],
    "ladji ladji": [
        4383
    ],
    "ladji": [
        4383
    ],
    "laci-laci": [
        4383
    ],
    "ladji-ladji": [
        4383
    ],
    "laitchi-laitchi": [
        4383
    ],
    "laitu-laitu": [
        4383
    ],
    "latja latji": [
        4383
    ],
    "latja": [
        4383
    ],
    "latji": [
        4383
    ],
    "latjalatji": [
        4383
    ],
    "latje latje": [
        4383
    ],
    "latje": [
        4383
    ],
    "latjilatji": [
        4383
    ],
    "latjoo-latjoo": [
        4383
    ],
    "latyoo-latyoo": [
        4383
    ],
    "ledji-ledji": [
        4383
    ],
    "ledjiledji": [
        4383
    ],
    "leitch-leitchi": [
        4383
    ],
    "litchoo-litchoo": [
        4383
    ],
    "litchy-litchy": [
        4383
    ],
    "lutchye-lutchye": [
        4383
    ],
    "lelak": [
        4384
    ],
    "lilau": [
        4385
    ],
    "lasalimu": [
        4386
    ],
    "lele (chad)": [
        4387
    ],
    "lolak": [
        4389
    ],
    "lithuanian sign language": [
        4390
    ],
    "lithuanian": [
        4390,
        4506,
        4507,
        5898,
        6822
    ],
    "lgk": [
        4390
    ],
    "lietuviu gestu kalba": [
        4390
    ],
    "lietuviu": [
        4390,
        4506,
        4507
    ],
    "lietuvių gestų kalba": [
        4390
    ],
    "lietuvių": [
        4506,
        4390,
        4507
    ],
    "ltsl": [
        4390
    ],
    "lauan": [
        4392
    ],
    "limba, east": [
        4393
    ],
    "lametin": [
        4394
    ],
    "limilngan": [
        4395
    ],
    "lumun": [
        4396
    ],
    "lomon": [
        4396
    ],
    "lamé": [
        4397
    ],
    "lembata, south": [
        4398
    ],
    "lembata": [
        4398,
        4402,
        4547
    ],
    "lamogai": [
        4399
    ],
    "lambicchhong": [
        4400
    ],
    "lambicchong": [
        4400
    ],
    "lambichhong": [
        4400
    ],
    "lambichong": [
        4400
    ],
    "lambitshong": [
        4400
    ],
    "lumbi": [
        4401
    ],
    "lembata, west": [
        4402
    ],
    "labalekan": [
        4402
    ],
    "lamkang": [
        4403,
        4404
    ],
    "lamkaang": [
        4403,
        4404
    ],
    "lamkang naga": [
        4403,
        4404
    ],
    "lamalanga": [
        4405
    ],
    "loltong": [
        4405
    ],
    "lambadi": [
        4406,
        4407,
        4408
    ],
    "labhani": [
        4406,
        4407,
        4408
    ],
    "labhani muka": [
        4406,
        4407,
        4408
    ],
    "lamadi": [
        4406,
        4407,
        4408
    ],
    "lamani": [
        4406,
        4407,
        4408
    ],
    "lambani": [
        4406,
        4407,
        4408
    ],
    "lambara": [
        4406,
        4407,
        4408
    ],
    "lavani": [
        4406,
        4407,
        4408
    ],
    "lemadi": [
        4406,
        4407,
        4408
    ],
    "lumadale": [
        4406,
        4407,
        4408
    ],
    "lombard": [
        4409
    ],
    "lombardo": [
        4409
    ],
    "limbum": [
        4410
    ],
    "limbom": [
        4410
    ],
    "llimbumi": [
        4410
    ],
    "lamatuka": [
        4411
    ],
    "lamatoka": [
        4411
    ],
    "lamalera": [
        4412
    ],
    "lebatukan": [
        4412
    ],
    "lamenu": [
        4413
    ],
    "lamen": [
        4413
    ],
    "lewo": [
        4549,
        4559,
        4413
    ],
    "lewo-lamen": [
        4413
    ],
    "lomaiviti": [
        4414
    ],
    "lake miwok": [
        4415
    ],
    "laimbue": [
        4416
    ],
    "lamboya": [
        4417
    ],
    "lumbee": [
        4418
    ],
    "lingala": [
        4419,
        4420,
        4421,
        4422
    ],
    "lingála": [
        4419,
        4420,
        4421,
        4422
    ],
    "langbashe": [
        4423
    ],
    "langbase": [
        4423
    ],
    "langbashi": [
        4423
    ],
    "langbasi": [
        4423
    ],
    "langbwasse": [
        4423
    ],
    "langwasi": [
        4423
    ],
    "lundayeh": [
        4425
    ],
    "lun": [
        4425
    ],
    "lun bawang": [
        4425
    ],
    "lun daya": [
        4425
    ],
    "lun dayah": [
        4425
    ],
    "lun daye": [
        4425
    ],
    "lun dayeh": [
        4425
    ],
    "lun dayoh": [
        4425
    ],
    "lun lod": [
        4425
    ],
    "lod": [
        4425
    ],
    "lundaya": [
        4425
    ],
    "lundaya putuk": [
        4425
    ],
    "lundayu": [
        4425
    ],
    "langobardic": [
        4426,
        4427
    ],
    "lanoh": [
        4428
    ],
    "lantanai": [
        4429
    ],
    "leningitij": [
        4430
    ],
    "linngithig": [
        4430
    ],
    "linngithigh": [
        4430
    ],
    "langam": [
        4432
    ],
    "lorediakarkar": [
        4433
    ],
    "langgo": [
        4434
    ],
    "lango (south sudan)": [
        4434
    ],
    "lamnso’": [
        4435
    ],
    "lamnsoʼ": [
        4435
    ],
    "lamnso'": [
        4435
    ],
    "lamnsok": [
        4435
    ],
    "lamso": [
        4435
    ],
    "longuda": [
        4436
    ],
    "languda": [
        4436
    ],
    "longura": [
        4436
    ],
    "lanima": [
        4437
    ],
    "lhanima": [
        4437
    ],
    "lonzo": [
        4438
    ],
    "lao wiang": [
        4439
    ],
    "lao-lum": [
        4439
    ],
    "lao-noi": [
        4439
    ],
    "lao-tai": [
        4439
    ],
    "laotian": [
        4439,
        5620,
        5621
    ],
    "laotian tai": [
        4439
    ],
    "lum lao": [
        4439
    ],
    "lum": [
        4439,
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "loda": [
        4440
    ],
    "loda’sch": [
        4440
    ],
    "lolodaka": [
        4440
    ],
    "lobiri": [
        4441
    ],
    "loocnon": [
        4442
    ],
    "looknon": [
        4442
    ],
    "loinang": [
        4443
    ],
    "loindang": [
        4443
    ],
    "logol": [
        4444
    ],
    "lukha": [
        4444
    ],
    "logo": [
        4445
    ],
    "lògòti": [
        4445
    ],
    "logoti": [
        4445
    ],
    "laarim": [
        4446
    ],
    "lariim": [
        4446
    ],
    "larim": [
        4446
    ],
    "lariminit": [
        4446
    ],
    "larimo": [
        4446
    ],
    "longarim": [
        4446
    ],
    "loma": [
        4447,
        4451,
        4452
    ],
    "loma (côte d'ivoire)": [
        4447
    ],
    "lomakka": [
        4447
    ],
    "lomapo": [
        4447
    ],
    "lomasse": [
        4447
    ],
    "lou": [
        4448,
        7331,
        7417
    ],
    "landogo": [
        4449
    ],
    "lomongo": [
        4450
    ],
    "lɔmɔngɔ": [
        4450
    ],
    "loghoma": [
        4451,
        4452
    ],
    "logoma": [
        4451,
        4452
    ],
    "loma (liberia)": [
        4451,
        4452
    ],
    "looma": [
        4451,
        4452
    ],
    "lorma": [
        4451,
        4452
    ],
    "lomwe, malawi": [
        4453
    ],
    "lomwe": [
        4453,
        5431
    ],
    "lombo": [
        4454
    ],
    "lopa": [
        4455,
        4465,
        4466
    ],
    "lopawa": [
        4455
    ],
    "lupa": [
        4455
    ],
    "lobala": [
        4456
    ],
    "loɓala": [
        4456
    ],
    "loghon": [
        4457
    ],
    "lorhon": [
        4457
    ],
    "loron": [
        4457
    ],
    "loniu": [
        4458
    ],
    "lonio": [
        4458
    ],
    "latooka": [
        4459,
        4460
    ],
    "lattuka": [
        4459,
        4460
    ],
    "latuka": [
        4459,
        4460
    ],
    "latuko": [
        4459,
        4460
    ],
    "lotuho": [
        4459,
        4460
    ],
    "lotuka": [
        4459,
        4460
    ],
    "lotuko": [
        4459,
        4460
    ],
    "lotuxo": [
        4459,
        4460
    ],
    "louisiana creole": [
        4461
    ],
    "louisiana creole french": [
        4461
    ],
    "louisiana french creole": [
        4461
    ],
    "lopi": [
        4462
    ],
    "lobu, tampias": [
        4463
    ],
    "lobu": [
        4463,
        6632,
        7839
    ],
    "loun": [
        4464
    ],
    "lhowa": [
        4465,
        4466
    ],
    "lhopa": [
        4465,
        4466
    ],
    "lo montang": [
        4465,
        4466
    ],
    "loke": [
        4465,
        4466,
        8745
    ],
    "loket": [
        4465,
        4466
    ],
    "lowa": [
        4465,
        4466
    ],
    "loyu": [
        4465,
        4466
    ],
    "lelepa": [
        4468
    ],
    "lepki": [
        4469
    ],
    "long phuri naga": [
        4470
    ],
    "longpfuri": [
        4470
    ],
    "longpfuru": [
        4470
    ],
    "lipo": [
        4471,
        4472
    ],
    "lolongo": [
        4471,
        4472
    ],
    "lolopo": [
        8761,
        8910,
        4471,
        4472
    ],
    "lopit": [
        4473
    ],
    "lafiit": [
        4473
    ],
    "lafit": [
        4473
    ],
    "lafite": [
        4473
    ],
    "lofit": [
        4473
    ],
    "lopid": [
        4473
    ],
    "loppit": [
        4473
    ],
    "lara’": [
        4474
    ],
    "luru": [
        4474
    ],
    "luri, northern": [
        4475
    ],
    "luristani": [
        4475
    ],
    "laurentian": [
        4477
    ],
    "laragia": [
        4478
    ],
    "laragiya": [
        4478
    ],
    "larakia": [
        4478
    ],
    "larakiya": [
        4478
    ],
    "larrakia": [
        4478
    ],
    "larrakiya": [
        4478
    ],
    "loarki": [
        4480
    ],
    "larestani": [
        4481
    ],
    "leera": [
        4484
    ],
    "liira": [
        4484
    ],
    "larantuka": [
        4486
    ],
    "larantuka malay": [
        4486
    ],
    "larevat": [
        4487
    ],
    "laravat": [
        4487
    ],
    "lemerig": [
        4488
    ],
    "leon": [
        4488
    ],
    "lasgerdi": [
        4489
    ],
    "lasjerdi": [
        4489
    ],
    "läsgerdi": [
        4489
    ],
    "läsjerdi": [
        4489
    ],
    "langue des signes burundaise": [
        4490
    ],
    "lishana deni": [
        4491
    ],
    "lishan hozaye": [
        4491
    ],
    "lishan hudaye": [
        4491
    ],
    "lusengo": [
        4492
    ],
    "losengo": [
        4492
    ],
    "lyons sign language": [
        4493
    ],
    "lyons": [
        4493
    ],
    "lish": [
        4494
    ],
    "lish monpa": [
        4494
    ],
    "lishpa": [
        4494
    ],
    "lacid": [
        4495
    ],
    "la chit": [
        4495
    ],
    "lachik": [
        4495
    ],
    "lachikwaw": [
        4495
    ],
    "lacik": [
        4495
    ],
    "laqi": [
        4495
    ],
    "lashi": [
        4495
    ],
    "lashi-maru": [
        4495
    ],
    "lasi": [
        4502,
        4495
    ],
    "lechi": [
        4495
    ],
    "leqi": [
        4495
    ],
    "leshi": [
        4495
    ],
    "letsi": [
        4495
    ],
    "latvian sign language": [
        4496
    ],
    "latvian": [
        4496,
        4542,
        4543
    ],
    "lzv": [
        4496
    ],
    "latviešu zīmju valoda": [
        4496
    ],
    "latviešu": [
        4542,
        4496
    ],
    "lusaamia": [
        4497
    ],
    "lusaamya-lugwe": [
        4497
    ],
    "lag": [
        4498
    ],
    "lagda": [
        4498
    ],
    "laos sign language": [
        4499
    ],
    "lengua de señas panameñas": [
        4500
    ],
    "lauisaranga": [
        4501
    ],
    "lau’u": [
        4501
    ],
    "lawu srenge": [
        4501
    ],
    "lawu": [
        4558,
        4501
    ],
    "lassi": [
        4502
    ],
    "lssiv": [
        4504
    ],
    "lengua de señas de sivia": [
        4504
    ],
    "lietuviškai": [
        4506,
        4507
    ],
    "lietuvių kalba": [
        4506,
        4507
    ],
    "litauische": [
        4506,
        4507
    ],
    "litewski": [
        4506,
        4507
    ],
    "litovskiy": [
        4506,
        4507
    ],
    "late middle chinese": [
        4508,
        4509
    ],
    "latgalian": [
        4510
    ],
    "latgaliešu": [
        4510
    ],
    "latgališu": [
        4510
    ],
    "labwor": [
        4511
    ],
    "lëb thur": [
        4511
    ],
    "lëb": [
        4511
    ],
    "leti (indonesia)": [
        4512
    ],
    "lir leti": [
        4512
    ],
    "latundê": [
        4513
    ],
    "leitodu": [
        4513
    ],
    "lutachoni": [
        4515
    ],
    "latu": [
        4516
    ],
    "luba-katanga": [
        4517
    ],
    "luba-shaba": [
        4517
    ],
    "luba-kasai": [
        4518
    ],
    "luba-lulua": [
        4518
    ],
    "luva": [
        4518
    ],
    "low lugbara": [
        4519
    ],
    "ludian": [
        4520
    ],
    "ludic": [
        4520
    ],
    "lyudic": [
        4520
    ],
    "lyudikovian": [
        4520
    ],
    "lüüdi": [
        4520
    ],
    "lüüdikiel": [
        4520
    ],
    "luvale": [
        4521
    ],
    "lovale": [
        4521
    ],
    "lubale": [
        4521
    ],
    "luena": [
        4521
    ],
    "lwena": [
        4521
    ],
    "laua": [
        4522
    ],
    "luiseño": [
        4523
    ],
    "luiseno": [
        4523
    ],
    "luna": [
        4524,
        5206
    ],
    "luna-inkongo": [
        4524
    ],
    "lunanakha": [
        4525
    ],
    "lolubo": [
        4526
    ],
    "luluba": [
        4526
    ],
    "lulubo": [
        4526
    ],
    "luimbi": [
        4527
    ],
    "luimbe": [
        4527
    ],
    "lwimbe": [
        4527
    ],
    "lwimbi": [
        4527
    ],
    "luo": [
        4529,
        4539,
        7253,
        4554
    ],
    "luo (kenya and tanzania)": [
        4529
    ],
    "lucumi": [
        4531
    ],
    "laura": [
        4532
    ],
    "laora": [
        4532
    ],
    "lei": [
        4533,
        4534,
        4535
    ],
    "lukhai": [
        4533,
        4534,
        4535
    ],
    "lusago": [
        4533,
        4534,
        4535
    ],
    "lusai": [
        4533,
        4534,
        4535
    ],
    "lusei": [
        4533,
        4534,
        4535
    ],
    "lushai": [
        4533,
        4534,
        4535
    ],
    "lushai-mizo": [
        4533,
        4534,
        4535
    ],
    "lushay": [
        4533,
        4534,
        4535
    ],
    "lushei": [
        4533,
        4534,
        4535
    ],
    "lushootseed": [
        4536,
        6946
    ],
    "lumba-yakkha": [
        4537
    ],
    "luwati": [
        4538
    ],
    "lawatiya": [
        4538
    ],
    "luo (cameroon)": [
        4539
    ],
    "luyia": [
        4540
    ],
    "luluhia": [
        4540
    ],
    "lubukusu": [
        4540
    ],
    "luri, southern": [
        4541
    ],
    "lor": [
        4541
    ],
    "lori-ye jonubi": [
        4541
    ],
    "latvian, standard": [
        4542
    ],
    "latviešu valoda": [
        4542
    ],
    "latviski": [
        4542
    ],
    "loikera": [
        4544
    ],
    "lokiera": [
        4544
    ],
    "lovaea": [
        4544
    ],
    "lovaia": [
        4544
    ],
    "lóvaia": [
        4544
    ],
    "lóvaia epulu": [
        4544
    ],
    "lóvaia epule": [
        4544
    ],
    "lavi": [
        4545,
        8116
    ],
    "lavy": [
        4545
    ],
    "lawi": [
        4545
    ],
    "lavukaleve": [
        4546
    ],
    "laube": [
        4546
    ],
    "laumbe": [
        4546
    ],
    "levuka": [
        4547
    ],
    "lewokukun": [
        4547
    ],
    "lewuka": [
        4547
    ],
    "lwalu": [
        4548
    ],
    "lwalwa": [
        4548
    ],
    "lewo eleng": [
        4549
    ],
    "luhanga": [
        4550
    ],
    "luwanga": [
        4550
    ],
    "lachi, white": [
        4551
    ],
    "lipupõ": [
        4551
    ],
    "lawa, eastern": [
        4552
    ],
    "laomian": [
        4553
    ],
    "lawmeh": [
        4553
    ],
    "luwo": [
        4554,
        4555
    ],
    "luuo": [
        4554,
        4555
    ],
    "luuhɔ": [
        4554
    ],
    "lewotobi": [
        4557
    ],
    "lamaholot": [
        6952,
        4557
    ],
    "lakurumau": [
        4560
    ],
    "lakuramau": [
        4560
    ],
    "laxudamau": [
        4560
    ],
    "loxodumau": [
        4560
    ],
    "layakha": [
        4561
    ],
    "lyngngam": [
        4562
    ],
    "lyngam": [
        4562
    ],
    "lyngym": [
        4562
    ],
    "luyana": [
        4563
    ],
    "louyi": [
        4563
    ],
    "luyaana": [
        4563
    ],
    "luyi": [
        4563
    ],
    "literary chinese": [
        4564,
        4565
    ],
    "litzlitz": [
        4566
    ],
    "lagalag": [
        4566
    ],
    "litzlitz-visele": [
        4566
    ],
    "lolnarrong": [
        4566
    ],
    "lainong": [
        4567
    ],
    "leinong naga": [
        4567
    ],
    "leinong": [
        4567
    ],
    "lenaung naga": [
        4567
    ],
    "lenaung": [
        4567
    ],
    "laz": [
        4568,
        4569,
        4570
    ],
    "laze": [
        4568,
        4569,
        4570
    ],
    "lazuri": [
        4568,
        4569,
        4570
    ],
    "lowland mazatec": [
        4581
    ],
    "lumbwa": [
        4591,
        4592
    ],
    "los": [
        6045,
        4593,
        4816
    ],
    "low malay": [
        4605
    ],
    "lembaamba": [
        4611,
        4671
    ],
    "longich": [
        4620
    ],
    "luso-malay": [
        4637
    ],
    "lagubi": [
        4645,
        5266
    ],
    "lingwa tas-sinjali maltija": [
        4663
    ],
    "lingwa": [
        4663,
        6416
    ],
    "lingwi tas-sinjali maltin": [
        4663
    ],
    "lingwi": [
        4663
    ],
    "lisongo": [
        4665
    ],
    "lissongo": [
        4665
    ],
    "lombole": [
        4667
    ],
    "limbede": [
        4671
    ],
    "limbere": [
        4671
    ],
    "lucía": [
        4673
    ],
    "leelalwarra": [
        4682
    ],
    "leelawarra": [
        4682
    ],
    "lengua de señas mexicana": [
        4728
    ],
    "lenguaje manual mexicana": [
        4728
    ],
    "lenguaje de señas mexicano": [
        4728
    ],
    "lenguaje de señas de méxico": [
        4728
    ],
    "lenguaje de signos mexicano": [
        4728
    ],
    "lenguaje de las manos": [
        4728
    ],
    "las": [
        4728,
        6354
    ],
    "lijili": [
        4748
    ],
    "lafia": [
        4748
    ],
    "ligili": [
        4748
    ],
    "lhao vo": [
        4787
    ],
    "lhao": [
        4787
    ],
    "lang": [
        6523,
        4787,
        9181,
        7524
    ],
    "langsu": [
        4787
    ],
    "langwa": [
        4787
    ],
    "lang’e": [
        8860,
        4787
    ],
    "laungaw": [
        4787
    ],
    "laungwaw": [
        4787
    ],
    "lawgore": [
        4787
    ],
    "lhaovo": [
        4787
    ],
    "liangsu": [
        4787
    ],
    "lovo": [
        4787
    ],
    "l'nui'simk": [
        4793
    ],
    "l’nui’simk": [
        4793,
        4794
    ],
    "lowland jicaltepec mixtec": [
        4807
    ],
    "languages": [
        4811,
        5136,
        6282,
        6819
    ],
    "lohiki": [
        4814
    ],
    "libres mixtec": [
        4816
    ],
    "libres": [
        4816
    ],
    "lan ten": [
        4824
    ],
    "lan": [
        4877,
        4824,
        5620,
        5621
    ],
    "lan tin": [
        4824
    ],
    "lanten": [
        4824
    ],
    "lantin": [
        4824
    ],
    "lowland yao": [
        4824
    ],
    "lan-tien": [
        4824
    ],
    "lantien": [
        4824
    ],
    "lan-sán chi": [
        4877
    ],
    "lan-sán": [
        4877
    ],
    "lelet": [
        4923
    ],
    "lomabaale": [
        4925
    ],
    "lemoi": [
        4979
    ],
    "luar": [
        5027
    ],
    "loi cim": [
        5028
    ],
    "leaf": [
        5039
    ],
    "lakher": [
        5048
    ],
    "launghu": [
        5054,
        5055
    ],
    "lschicana": [
        5076
    ],
    "lengua de señas chicana": [
        5076
    ],
    "lenguaje manual maya": [
        5076
    ],
    "lakes": [
        5106
    ],
    "langda": [
        5107
    ],
    "lhamtés": [
        5116,
        5263,
        8267
    ],
    "lagaw": [
        5188
    ],
    "lagau": [
        5188
    ],
    "langgus": [
        5188
    ],
    "langus": [
        5188
    ],
    "linggo": [
        5188
    ],
    "lawta": [
        5193,
        5194,
        8000
    ],
    "lugisu": [
        5252
    ],
    "lumasaaba": [
        5252
    ],
    "lugagon": [
        5291
    ],
    "lokoli": [
        5322
    ],
    "lokukoli": [
        5322
    ],
    "lengua de signos nicaragüense": [
        5352
    ],
    "lenguaje de signos nicaragüense": [
        5352
    ],
    "leeko": [
        5366
    ],
    "lego": [
        5366
    ],
    "lekon": [
        5366
    ],
    "low german": [
        5376,
        5375,
        6086
    ],
    "low saxon": [
        5375,
        5376
    ],
    "lutos": [
        5382,
        5383
    ],
    "lhotshammikha": [
        5385,
        5386
    ],
    "lap": [
        5396
    ],
    "lii dhao": [
        5415
    ],
    "lomlom": [
        5417
    ],
    "lingombe": [
        5423
    ],
    "lomue": [
        5431
    ],
    "li nias": [
        5468
    ],
    "lwaà": [
        5471
    ],
    "lendu-sud": [
        5491
    ],
    "lotha": [
        5496
    ],
    "lhota": [
        5496
    ],
    "lotha naga": [
        5496
    ],
    "lutha": [
        5496
    ],
    "liangmai": [
        5501
    ],
    "liangkhon": [
        5501
    ],
    "lianglad": [
        5501
    ],
    "liangmai naga": [
        5501
    ],
    "liangmei": [
        5501
    ],
    "liyang": [
        5501
    ],
    "lyangmay": [
        5501
    ],
    "lyangmei": [
        5501
    ],
    "lyengmai": [
        5501
    ],
    "lel": [
        5509,
        5510
    ],
    "lekongo": [
        5513
    ],
    "lunyala": [
        5546
    ],
    "linyali": [
        5549
    ],
    "lao naga": [
        5554
    ],
    "law": [
        5554
    ],
    "lendumu": [
        5564
    ],
    "lindumu": [
        5564
    ],
    "luppa": [
        5566
    ],
    "letemboi": [
        5582
    ],
    "losu": [
        5589
    ],
    "lujere": [
        5604
    ],
    "la nya": [
        5620,
        5621
    ],
    "lan na": [
        5620,
        5621
    ],
    "lanatai": [
        5620,
        5621
    ],
    "lanna": [
        5620,
        5621
    ],
    "lannatai": [
        5620,
        5621
    ],
    "lhéchelesem": [
        5628
    ],
    "lophomi": [
        5681
    ],
    "lower nossob": [
        5682
    ],
    "lower-nosop": [
        5682
    ],
    "leboa": [
        5695,
        5696
    ],
    "lontomba": [
        5717
    ],
    "luntumba": [
        5717
    ],
    "lunyole": [
        5733,
        5790
    ],
    "lonyole": [
        5733
    ],
    "lutze": [
        5737
    ],
    "lutzu": [
        5737
    ],
    "lungchow": [
        5745
    ],
    "longandu": [
        5772
    ],
    "lomi": [
        5781,
        5782,
        5783
    ],
    "linyanga-le": [
        5789
    ],
    "lunyore": [
        5790
    ],
    "lunyaneka": [
        5797
    ],
    "lunyoro": [
        5801
    ],
    "leuangiua": [
        5867
    ],
    "lord howe": [
        5867
    ],
    "lord": [
        5867
    ],
    "luangiua": [
        5867
    ],
    "luaniua": [
        5867
    ],
    "livvi-karelian": [
        5896
    ],
    "livvi": [
        5896
    ],
    "livvikovian": [
        5896
    ],
    "livvikovskij jazyk": [
        5896
    ],
    "livvikovskij": [
        5896
    ],
    "livvin kieli": [
        5896
    ],
    "livvin": [
        5896
    ],
    "loombo": [
        5910
    ],
    "laamoot": [
        5915
    ],
    "lingao": [
        5921
    ],
    "limkow": [
        5921
    ],
    "linkow": [
        5921
    ],
    "limkou": [
        5921
    ],
    "litoro": [
        5990
    ],
    "loushiru": [
        5993
    ],
    "louxiru": [
        5993
    ],
    "louxiur": [
        5993
    ],
    "loani": [
        6010
    ],
    "laghmani": [
        6034
    ],
    "los reyes metzontla popoloca": [
        6045
    ],
    "leemak": [
        6050
    ],
    "lemak": [
        6050
    ],
    "lango pardhi": [
        6076
    ],
    "lahwi": [
        6087,
        6088
    ],
    "lower morehead": [
        6102
    ],
    "lorraine franconian": [
        6110
    ],
    "lorraine": [
        6110
    ],
    "lottrìnger plàtt": [
        6110
    ],
    "lottrìnger": [
        6110
    ],
    "lá": [
        9110,
        6124
    ],
    "lao phuan": [
        6133,
        6134,
        6135
    ],
    "lao phuon": [
        6133,
        6135
    ],
    "lower piman": [
        6142
    ],
    "loridja": [
        6160
    ],
    "lanzog": [
        6163
    ],
    "lower pokomo": [
        6168
    ],
    "leo": [
        6175
    ],
    "lieng": [
        6178
    ],
    "lengyel": [
        6180,
        6181
    ],
    "lenku": [
        6180,
        6181
    ],
    "lu’a": [
        6186
    ],
    "liang": [
        6191,
        8804
    ],
    "liang palaung": [
        6191
    ],
    "lai yu": [
        6201
    ],
    "lailai": [
        6201
    ],
    "lingua franca": [
        6212
    ],
    "logat papua": [
        6222
    ],
    "logat": [
        6222
    ],
    "lao phong": [
        6247
    ],
    "lower lake pomo": [
        6257
    ],
    "luís": [
        6277
    ],
    "luis": [
        6277
    ],
    "latuwewakon": [
        6281
    ],
    "lua'": [
        6283
    ],
    "lun’gwiye": [
        6286
    ],
    "lsp": [
        6292
    ],
    "lengua de signos peruana": [
        6292
    ],
    "lenguaje de señas peruana": [
        6292
    ],
    "lenguaje de señas peruano": [
        6292
    ],
    "lao mai": [
        6300
    ],
    "lao prai": [
        6300
    ],
    "lua prai": [
        6300
    ],
    "lua’": [
        6300
    ],
    "lintang": [
        6311
    ],
    "local sign language": [
        6319
    ],
    "local": [
        6319,
        9077,
        9078
    ],
    "lgp": [
        6321
    ],
    "língua gestual portuguesa": [
        6321
    ],
    "lamap": [
        6326
    ],
    "lao muh": [
        6365
    ],
    "la purisima": [
        6373
    ],
    "li-li-sha": [
        6379
    ],
    "lspy": [
        6387
    ],
    "lengua de señas del paraguay": [
        6387
    ],
    "lengua de señas paraguaya": [
        6387
    ],
    "llacón": [
        6397
    ],
    "lambayeque": [
        6400
    ],
    "linwaras": [
        6400
    ],
    "lambayeque quechua": [
        6400
    ],
    "llakwash": [
        6426,
        6403
    ],
    "loja": [
        6420
    ],
    "loja highland quichua": [
        6420
    ],
    "loja quichua": [
        6420
    ],
    "lima": [
        6421
    ],
    "lowland napo quechua": [
        6424
    ],
    "lowland napo quichua": [
        6424
    ],
    "lamano": [
        6426
    ],
    "lamas kichwa": [
        6426
    ],
    "lamas": [
        6426
    ],
    "lamas quechua": [
        6426
    ],
    "lamista": [
        6426
    ],
    "lamisto": [
        6426
    ],
    "llakwash quechua": [
        6426
    ],
    "llakwash runashimi": [
        6426
    ],
    "llaqwash": [
        6430
    ],
    "lulogooli": [
        6459
    ],
    "llogole": [
        6459
    ],
    "llugule": [
        6459
    ],
    "logooli": [
        6459
    ],
    "lugooli": [
        6459
    ],
    "luragoli": [
        6459
    ],
    "lingkhim": [
        6471
    ],
    "longmi": [
        6479,
        6480
    ],
    "lellewao": [
        6485
    ],
    "lellewau": [
        6485
    ],
    "limi": [
        8833,
        6524
    ],
    "lindiri": [
        6525
    ],
    "lavo": [
        6544
    ],
    "lomavren": [
        6548
    ],
    "lom": [
        6548
    ],
    "lmgr": [
        6559
    ],
    "lsr": [
        6559
    ],
    "limba semnelor române": [
        6559
    ],
    "limbajul mimico-gestual romanesc": [
        6559
    ],
    "limbajul": [
        6559
    ],
    "limbajul semenelor romanesc": [
        6559
    ],
    "lunda kambove": [
        6568
    ],
    "lunda-kamboro": [
        6568
    ],
    "luunda": [
        6568
    ],
    "luwunda": [
        6568
    ],
    "langlo": [
        6570
    ],
    "langlong": [
        6570
    ],
    "langlu": [
        6570
    ],
    "langrong": [
        6570
    ],
    "lengreng": [
        6570
    ],
    "limba română": [
        6575,
        6576,
        6578,
        6579
    ],
    "luwu-rongkong": [
        6581
    ],
    "luwu’": [
        6581
    ],
    "la-oang": [
        6586
    ],
    "lugungu": [
        6617
    ],
    "luduuli": [
        6618
    ],
    "lemko": [
        6619,
        6620
    ],
    "luguru": [
        6621
    ],
    "lughuru": [
        6621
    ],
    "lugulu": [
        6621
    ],
    "lobu, lanas": [
        6632
    ],
    "lanas": [
        6632
    ],
    "lanas lobu": [
        6632
    ],
    "luwila": [
        6639
    ],
    "luwira": [
        6639
    ],
    "lwila": [
        6639
    ],
    "lwira": [
        6639
    ],
    "lubulebule": [
        6640
    ],
    "lwamba": [
        6640
    ],
    "luchu": [
        6648
    ],
    "lokop": [
        6672
    ],
    "lombok": [
        6674,
        6675
    ],
    "lahul bhoti": [
        6711,
        6712
    ],
    "logudorese": [
        6718
    ],
    "lankan": [
        6725,
        7083
    ],
    "lk": [
        6725,
        6864,
        6865,
        7083,
        7298,
        8070
    ],
    "lallans": [
        6731
    ],
    "lapp": [
        6770,
        6771,
        6963,
        6980
    ],
    "lsbf": [
        6799
    ],
    "lsfb": [
        6799
    ],
    "langue des signes belge francophone": [
        6799
    ],
    "langue des signes de belgique francophone": [
        6799
    ],
    "logang": [
        6818
    ],
    "lusinga": [
        6818
    ],
    "lowland lithuanian": [
        6822
    ],
    "lenkaitahe": [
        6824
    ],
    "liambata": [
        6824
    ],
    "l’arabe du tchad": [
        6855,
        6856
    ],
    "l’arabe": [
        6855,
        6856
    ],
    "ludumor": [
        6858
    ],
    "lachengpa": [
        6879
    ],
    "lachungpa": [
        6879
    ],
    "lhoke": [
        6879
    ],
    "lower umpqua": [
        6882
    ],
    "latoma": [
        6884
    ],
    "lamassa": [
        6905
    ],
    "lambom": [
        6905
    ],
    "lis-si": [
        6944
    ],
    "lingua dei segni della svizzera italiana": [
        6944
    ],
    "lower silesian": [
        6947
    ],
    "lule": [
        7947,
        6970
    ],
    "lule sami": [
        6970
    ],
    "long bano": [
        6979
    ],
    "lopar": [
        6980,
        6981
    ],
    "luba-garenganze": [
        6995,
        6996
    ],
    "luba-sanga": [
        6995,
        6996
    ],
    "lamangkau": [
        7010
    ],
    "lao song": [
        7023,
        7024
    ],
    "lao song dam": [
        7023,
        7024
    ],
    "lohendo": [
        7028
    ],
    "luba-songi": [
        7039
    ],
    "lusonge": [
        7039
    ],
    "loreto-ucayali spanish": [
        7061
    ],
    "loreto-ucayali": [
        7061
    ],
    "lìsháù": [
        7076
    ],
    "langulo": [
        7142
    ],
    "lse": [
        7144
    ],
    "lengua de señas española": [
        7144
    ],
    "lengua de signos española": [
        7144
    ],
    "lsf-sr": [
        7146
    ],
    "langage gestuelle": [
        7146
    ],
    "langage": [
        7146
    ],
    "langue des signes suisse romande": [
        7146
    ],
    "liana-seti": [
        7161
    ],
    "liambata-kobi": [
        7161
    ],
    "liana": [
        7161
    ],
    "lianan": [
        7161
    ],
    "lower stieng": [
        7177
    ],
    "lushnu": [
        7214
    ],
    "luo abasuba": [
        7253
    ],
    "lesighu": [
        7255
    ],
    "lisighu": [
        7255
    ],
    "lisigu": [
        7255
    ],
    "la aluwa": [
        7262
    ],
    "la’alua": [
        7262
    ],
    "la’arua": [
        7262
    ],
    "lha’alua": [
        7262
    ],
    "lishana atiga": [
        7268
    ],
    "lshan sray": [
        7275
    ],
    "lshan": [
        7275
    ],
    "lishana kaldaya": [
        7277
    ],
    "lower tanana": [
        7301
    ],
    "lowland tarahumara": [
        7303
    ],
    "lanyu": [
        7314
    ],
    "lorabada": [
        7331
    ],
    "latsitsege": [
        7364
    ],
    "lintsitsege": [
        7364
    ],
    "luwa": [
        7392
    ],
    "lwa": [
        7392
    ],
    "lia-tetun": [
        7403
    ],
    "latege": [
        7415
    ],
    "lawunuia": [
        7453
    ],
    "lithiro": [
        7497
    ],
    "littiro": [
        7497
    ],
    "lɛ̀ʼ tikarì": [
        7505
    ],
    "lɛ̀ʼ": [
        7505
    ],
    "laing": [
        7524
    ],
    "laeng": [
        7524
    ],
    "langya": [
        7555
    ],
    "lubwisi": [
        7570
    ],
    "lubwissi": [
        7570
    ],
    "lao doi": [
        7577
    ],
    "levei-drehet": [
        7583
    ],
    "levei-ndrehet": [
        7583
    ],
    "lama bhote": [
        7599
    ],
    "lengmo": [
        7599
    ],
    "lomorik": [
        7606
    ],
    "lomuriki": [
        7606
    ],
    "litembo": [
        7609
    ],
    "letuama": [
        7617
    ],
    "letuhama": [
        7617
    ],
    "lenakel": [
        7623
    ],
    "lénakel": [
        7623
    ],
    "lea fakatonga": [
        7638
    ],
    "lea": [
        7638
    ],
    "l’aqtac": [
        7639
    ],
    "lowland totonaca": [
        7650
    ],
    "lamtoka": [
        7665
    ],
    "lantoka": [
        7665
    ],
    "lehali": [
        7684
    ],
    "lokuru": [
        7692
    ],
    "lishán noshan": [
        7706
    ],
    "lishán": [
        7706
    ],
    "lakhlokhi": [
        7706
    ],
    "lakhlókh": [
        7706
    ],
    "lishanid nash didán": [
        7706
    ],
    "lishanán": [
        7706
    ],
    "lishán didán": [
        7706
    ],
    "lacustre": [
        7752
    ],
    "lower ta'oih": [
        7769
    ],
    "long wat": [
        7778
    ],
    "lache": [
        7788
    ],
    "luhchi yoroni": [
        7795
    ],
    "luhchi": [
        7795
    ],
    "lower rogue river": [
        7799
    ],
    "londru": [
        7831
    ],
    "laya": [
        7869
    ],
    "laia": [
        8338,
        7869
    ],
    "lat": [
        7879
    ],
    "lugha ya alama ya tanzania": [
        7879
    ],
    "lugha": [
        7879
    ],
    "laṭlaṣ": [
        7884
    ],
    "lsu": [
        7925
    ],
    "lengua de señas uruguaya": [
        7925
    ],
    "lskb": [
        7940
    ],
    "língua de sinais kaapor brasileira": [
        7940
    ],
    "lule-tonocoté": [
        7947
    ],
    "longh": [
        7954
    ],
    "lasam": [
        7963
    ],
    "lenape": [
        7974
    ],
    "lenni-lenape": [
        7974
    ],
    "lawoi’": [
        8000
    ],
    "lawoi": [
        8000
    ],
    "lumoh lawoi’": [
        8000
    ],
    "lumoh": [
        8000
    ],
    "löyöp": [
        8006
    ],
    "lehalurup": [
        8006
    ],
    "lote": [
        8035
    ],
    "lohote": [
        8035
    ],
    "livanuma": [
        8061
    ],
    "luvenda": [
        8067,
        8068
    ],
    "luvenḓa": [
        8067,
        8068
    ],
    "lungalunga": [
        8110
    ],
    "lungalungá": [
        8110
    ],
    "lovono": [
        8128
    ],
    "lavana": [
        8128
    ],
    "lambumbu": [
        8129
    ],
    "lengua de señas venezolana": [
        8140
    ],
    "lscv": [
        8141
    ],
    "lspv": [
        8141
    ],
    "lsv": [
        8141
    ],
    "lengua de signos valenciana": [
        8141
    ],
    "llengua de signes valenciana": [
        8141
    ],
    "llengua de signes en la comunitat valenciana": [
        8141
    ],
    "llengua de signes del país valencià": [
        8141
    ],
    "luvure": [
        8145
    ],
    "liwanzi": [
        8196
    ],
    "leewakya": [
        8217
    ],
    "lebu’ kulit": [
        8226
    ],
    "lebu’": [
        8226
    ],
    "lower pyramid": [
        8268
    ],
    "longto": [
        8314
    ],
    "longbo": [
        8314
    ],
    "lonto": [
        8314
    ],
    "leearawa": [
        8328
    ],
    "leearrawa": [
        8328
    ],
    "lower burdekin": [
        8412
    ],
    "lxloukxle": [
        8452
    ],
    "lavau": [
        8459
    ],
    "lower ahia": [
        8459
    ],
    "lasan": [
        8514
    ],
    "loup b": [
        8518
    ],
    "loup": [
        8518,
        8525
    ],
    "lycian": [
        8519
    ],
    "lydian": [
        8520
    ],
    "lemnian": [
        8521
    ],
    "ligurian (ancient)": [
        8522
    ],
    "liburnian": [
        8523
    ],
    "loup a": [
        8525
    ],
    "lepontic": [
        8526
    ],
    "lusitanian": [
        8527
    ],
    "langue des signes du maroc": [
        8548
    ],
    "langue des signes marocaine": [
        8548
    ],
    "lower mori": [
        8555
    ],
    "lusoga": [
        8577
    ],
    "laklanô": [
        8579
    ],
    "likpakpaanl": [
        8582,
        8583
    ],
    "ludhigh": [
        8596
    ],
    "luthigh": [
        8596
    ],
    "lɔ:tig": [
        8596
    ],
    "lamertiviri": [
        8686
    ],
    "llagua": [
        8720
    ],
    "llaruro": [
        8721
    ],
    "lokaa": [
        8745
    ],
    "lokạạ": [
        8745
    ],
    "loka": [
        8745
    ],
    "lokö": [
        8745
    ],
    "lokǝ": [
        8745
    ],
    "luko": [
        8745
    ],
    "lao phula": [
        8753
    ],
    "lolopho": [
        8761
    ],
    "lulupu": [
        8761
    ],
    "luolu": [
        8761
    ],
    "lotkohiwar": [
        8766
    ],
    "lalo, dongshanba": [
        8801
    ],
    "lalo": [
        8801,
        8952
    ],
    "lalu": [
        8809,
        8947,
        8801,
        8952
    ],
    "lalupa": [
        8801
    ],
    "lalupu": [
        8801
    ],
    "liang sek": [
        8804
    ],
    "lalu, eastern": [
        8809
    ],
    "luowu": [
        8810
    ],
    "luwu": [
        8810
    ],
    "lyaasa": [
        8822
    ],
    "lyassa": [
        8822
    ],
    "liumi": [
        8833
    ],
    "langnian": [
        8834
    ],
    "langnian buyang": [
        8834
    ],
    "laluo": [
        8835,
        8952
    ],
    "lahi": [
        8840
    ],
    "lllameo": [
        8842
    ],
    "lang'e": [
        8860
    ],
    "la’u": [
        8860
    ],
    "lao yuai": [
        8882
    ],
    "labo phowa": [
        8884
    ],
    "labopho": [
        8884
    ],
    "laotshipu": [
        8888
    ],
    "laghï": [
        8890
    ],
    "lapa": [
        8890
    ],
    "larhwo": [
        8890
    ],
    "la’ou": [
        8890
    ],
    "língua geral": [
        8896
    ],
    "língua geral amazônica": [
        8896
    ],
    "liu yao": [
        8898
    ],
    "lolopo, southern": [
        8910
    ],
    "liem chau": [
        8923,
        8924,
        8925,
        8926
    ],
    "liem": [
        8923,
        8924,
        8925,
        8926
    ],
    "lowland nung": [
        8923,
        8924,
        8925,
        8926
    ],
    "luruty-tapuya": [
        8929
    ],
    "lalu, western": [
        8947
    ],
    "lalo, central": [
        8952
    ],
    "lalaw": [
        8952
    ],
    "lalopa": [
        8952
    ],
    "langjia buyang": [
        8964
    ],
    "langjia": [
        8964
    ],
    "long teru": [
        8997
    ],
    "long jegan berawan": [
        8998
    ],
    "long terawan": [
        9002
    ],
    "lower waria": [
        9051
    ],
    "liujiang": [
        9075,
        9076
    ],
    "liujiang zhuang": [
        9075,
        9076
    ],
    "local malay": [
        9077,
        9078
    ],
    "lianshan": [
        9079
    ],
    "lianshan zhuang": [
        9079
    ],
    "liuqian": [
        9080
    ],
    "liuqian zhuang": [
        9080
    ],
    "leke": [
        9104
    ],
    "lá vàng": [
        9110
    ],
    "león": [
        9119
    ],
    "lachiguiri": [
        9120
    ],
    "lachiguiri zapotec": [
        9120
    ],
    "latuvi zapotec": [
        9123
    ],
    "latuvi": [
        9123
    ],
    "lachixila": [
        9129
    ],
    "lachixío": [
        9131
    ],
    "lachixío zapotec": [
        9131
    ],
    "loxicha": [
        9143,
        9165
    ],
    "lapaguía-guivini": [
        9162
    ],
    "lapaguía-guivini zapotec": [
        9162
    ],
    "lapaguia": [
        9162
    ],
    "lapaguía": [
        9162
    ],
    "loxicha zapotec": [
        9165
    ],
    "laraki": [
        9176
    ],
    "linguistic": [
        9180
    ],
    "long an": [
        9184
    ],
    "long’an": [
        9184
    ],
    "longyin": [
        9188
    ],
    "longzhou": [
        9188
    ]
};
